import { LINE_OFFICIAL_ACCOUNT_URL } from "./config";

const ALLOWED_LINE_URL_PREFIXES = [
  "https://line.me/",
  "https://liff.line.me/",
  "https://lin.ee/",
] as const;

export function isAllowedLineUrl(url: string): boolean {
  return ALLOWED_LINE_URL_PREFIXES.some((prefix) => url.startsWith(prefix));
}

export function getValidLineOfficialAccountUrl(): string | null {
  if (!LINE_OFFICIAL_ACCOUNT_URL || !isAllowedLineUrl(LINE_OFFICIAL_ACCOUNT_URL)) {
    return null;
  }

  return LINE_OFFICIAL_ACCOUNT_URL;
}
